import ArrowLineDown from 'assets/Icons/Arrow/ArrowLineDown';
import ArrowLineUp from 'assets/Icons/Arrow/ArrowLineUp';
import QueryCustomedPagination from 'components/Pagination/QueryCustomedPagination';
import { HeaderWrapper, Layout, TableCell, TableLayout } from 'components/Hospital/PaginationForms';
import { CLUserLookupListHeader, clUserLookupListWidth } from 'constants/pagination';
import { NothingDataInManagingPatientsPagination } from 'pages/Admin/DCK/AddDiagnosisPage/NothingDataInPagination';
import { OtherSortingButton } from 'styles/Global/buttonStyles';
import { ICLUserInfo } from 'models/CL/CLBasicInterface';
import CLUserLookupTable from './CLUserLookupTable';

interface CLUserLookupPaginationProps {
    currentPage: number;
    totalPages?: number;
    pageGroup: number;
    currentData?: ICLUserInfo[];
    initNumber?: number;
    sortField: string;
    sortDirections: Record<string, boolean>;
    handleSorting: (type: string) => void;
    handlePageChange: (page: number, newGroup?: number) => void;
    handleResetButton: () => void;
}

const CLUserLookupPagination = ({
    currentPage,
    totalPages,
    pageGroup,
    currentData,
    initNumber,
    sortField,
    sortDirections,
    handleSorting,
    handlePageChange,
    handleResetButton,
}: CLUserLookupPaginationProps) => {
    const tableBody =
        !currentData || currentData.length === 0 ? (
            <NothingDataInManagingPatientsPagination initNumber={initNumber} handleResetButton={handleResetButton} type='clUserLookup' />
        ) : (
            <CLUserLookupTable data={currentData} />
        );

    return (
        <Layout>
            <TableLayout>
                <HeaderWrapper>
                    {CLUserLookupListHeader.map((name, idx) => {
                        const isRegistration = name.type === 'registrationTimestamp';
                        return (
                            <TableCell
                                key={name.type}
                                $idx={idx}
                                $width={clUserLookupListWidth[idx]}
                                $type='header'
                                $justifyContent='space-between'
                                cellType={name.type}
                                $maxWidth={idx === 6 ? '60px' : undefined}
                                $show='always'
                            >
                                {name.title}
                                {isRegistration && (
                                    <OtherSortingButton onClick={() => handleSorting('registrationTimestamp')}>
                                        {sortField === 'registrationTimestamp' && sortDirections.registrationTimestamp ? <ArrowLineUp /> : <ArrowLineDown />}
                                    </OtherSortingButton>
                                )}
                            </TableCell>
                        );
                    })}
                </HeaderWrapper>
                {tableBody}
            </TableLayout>
            {currentData && totalPages !== 0 && (
                <QueryCustomedPagination currentPage={currentPage} onChangeCurrentPage={handlePageChange} sectionIndex={pageGroup} totalPages={totalPages} />
            )}
        </Layout>
    );
};

export default CLUserLookupPagination;
